import { ICategoryStrategy, NextAction } from "./ICategoryStrategy";
import { Category } from "@/types";
import { fetchCategoryHierarchyByKey } from "@/apis";
import { hashEncode } from "@/utility";

type ServiceCategory = Category & {
    hasChildren: boolean;
    children?: Category[] | null;
};

export class ServiceCategoryStrategy implements ICategoryStrategy {
    readonly useUrlDepth = true;
    readonly autoSelectSingleCategory = true;

    async fetchCategories(slug: string): Promise<Category[]> {
        const response = await fetchCategoryHierarchyByKey(slug, {
            sendChildren: true,
            sendAncestors: false,
        });
        const category = response?.data?.response as ServiceCategory | undefined;

        if (!category) return [];
        return category.hasChildren ? category.children ?? [] : [category];
    }

    onLeafCategorySelected(category?: Category): NextAction {
        return { kind: 'navigate', to: `/search?cid=${hashEncode(category?.id)}`, replace: true }
    }

    getNextAction(category: Category): NextAction {
        if (!(category as ServiceCategory).hasChildren) {
            return this.onLeafCategorySelected(category);
        }

        return { kind: 'navigate', to: `/services/${category.key}` }
    }
}
